export default __webpack_public_path__ + "static/events-light-90e4a05a29513d05cd4a14d3e0625ec2.png";